import { render, staticRenderFns } from "./audioSettings.vue?vue&type=template&id=967715a4"
import script from "./audioSettings.vue?vue&type=script&lang=js"
export * from "./audioSettings.vue?vue&type=script&lang=js"
import style0 from "./audioSettings.vue?vue&type=style&index=0&id=967715a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports